import React, { Component } from 'react';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'

class Help extends Component{
  constructor(props) {
    super(props);

    this.state = {
      helpOpen: false
    }

  }

  toggleHelpSection = () => {
    console.log("Opening help section")
    this.setState({
      helpOpen: this.state.helpOpen ? false : true
    })
  }
  
  render() {
    const styles = this.props.styles;

    return(
      <div className={styles.helpButtonContainer}>
        <button className={styles.helpButton} onClick={() => this.toggleHelpSection()}>{Lang.translate('help:button', this.props.location.pathname)}</button>
        <div className={styles.helpOverlay} onClick={() => this.toggleHelpSection()} style={this.state.helpOpen ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'}}>
          <div className={styles.helpOverlayContent}>
            <div className={styles.helpCloseButton} onClick={() => this.toggleHelpSection()}>
            <svg width="25px" height="25px" viewBox="0 0 62 62" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <defs></defs>
                <g id="Symbols" stroke="none" fill="none">
                    <g id="Exit" transform="translate(1.000000, 1.000000)">
                        <g>
                            <circle id="Oval-2" stroke="#FFFFFF" fill="#0D2EA0" cx="30" cy="30" r="30"></circle>
                            <g id="Group" transform="translate(30.500000, 30.500000) rotate(45.000000) translate(-30.500000, -30.500000) translate(13.000000, 13.000000)" fill="#FFFFFF">
                                <rect id="Rectangle-8" x="0" y="15" width="35" height="5"></rect>
                                <rect id="Rectangle-8" x="15" y="0" width="5" height="35"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            </div>
            <h2>{Lang.translate('help:title', this.props.location.pathname)}</h2>
            <div className={styles.helpContent}>
              <h3>Nutzen Sie unseren Service zum ersten Mal?</h3>
              <p>Unsere Step-by-Step Anleitung führt Sie durch die wichtigsten Funktionen und erklärt Ihnen die Handhabung des Produktionskalkulators.</p>
              <p>Mit Hilfe des Kalkulators können Sie anhand eigener Werte die Gewinnschwelle und den Deckungsbeitrag für das erste und zweite Jahr berechnen. Außerdem werden Ihnen diese Werte graphisch dargestellt, sodass Sie einen einfachen und schnellen Überblick erhalten.</p>
              <p>Geben Sie die gewünschten Werte in die Felder mit den orange hinterlegten Zahlen ein. Sie können folgende Werte individuell anpassen:</p>
              <ul>
                <li>das Nachfragevolumen</li>
                <li>die Materialkosten pro Stück</li>
                <li>die Produktionswochen</li>
                <li>die tägliche Arbeitszeit</li>
                <li>die Personalkosten pro Stunde</li>
                <li>den Listenpreis pro Stück</li>
              </ul>
              <p>Durch Ihre Angaben werden weitere Werte, wie zum Beispiel die Druck- oder Personalkosten, neu kalkuliert und angezeigt.</p>
              <p>Auch ist es möglich, die Variablen der Produkte zu ändern. Wählen Sie zum Beispiel die Zahl der Tintenpackungen, die Größe der Druckflächen oder den Farbauftrag aus, um Ihre Kalkulation zu spezifizieren.</p>
              <p>Sie können im unteren Bereich des Kalkulators eine Auflistung des Ertrags Ihrer Investitionen in Form einer Tabelle einsehen. Unterstützt wird die Anzeige von einem Balken- und einem Ringdiagramm, welche die Aufteilung des geschätzten Umsatzes in variable Kosten, die Investitionssumme und den übrig bleibenden Deckungsbetrag einteilt.</p>
              <h4>Benötigen Sie weitere Hilfe? Wir sind gerne für Sie da!</h4>
              <p>Über unser Kontaktformular erreichen Sie unsere fachkundigen Brother Representatives und können Ihre Fragen, Anregungen oder Wünsche mitteilen. Nutzen Sie hierzu einfach den Button „Kontakt aufnehmen“ im unteren Bereich unserer Webseite.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Help);



// WEBPACK FOOTER //
// ./src/components/calculator/help/help.js